<script>
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import helperMethods from '@/helpers'
import Card from 'primevue/card'
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import Toast from 'primevue/toast';

export default {
    metaInfo:{
        title: "Replays list"
    },
    props: {
        replays: Array,

        flash: Object,
    },
    components:{
        AuthenticatedLayout, Card, DataTable, Column, Button, Toast
    },
    data(){
        return {

        }
    },
    watch:{
        flash(newFlash, oldFlash){
            //console.log(newFlash.success);
            if(newFlash.success !== null){
                this.$toast.add({severity:'success', summary: 'Success', detail: newFlash.success, life: 3000});
            }
            if(newFlash.error !== null){
                this.$toast.add({severity:'error', summary: 'Error', detail: newFlash.error, life: 5000});
            }
        }
    },
    methods:{
        ...helperMethods,
        goToReplay(id){
            this.$inertia.get("/replay/"+id);
        },
        onRowSelect(event){
            this.$inertia.get("/replay/"+event.data.id);
        },
        n2br(string)
        {
            if(!string) return "";
            return string.replace(/(?:\r\n|\r|\n)/g, '</br>');
        },
        deleteAllReplays(id){
            this.$inertia.post('/replays/delete', );
        }
    }
}
</script>

<template>

    <AuthenticatedLayout>
        <h2>Бэктестинг ботов</h2>

        <Card class="mb-4 ">
            <template #content>
                <Button @click="deleteAllReplays" class="p-button-info p-button-outlined">Удалить все реплеи</Button>
            </template>
        </Card>

        <Card>
            <template #content>
                <div v-if="replays.length > 0">
                    <DataTable :value="replays" selectionMode="single" dataKey="id" @row-select="onRowSelect">
                        <Column header="" field="id" ></Column>
                        <Column header="Запущено" >
                            <template #body="slotProps">
                                {{timezoned(slotProps.data.created_at)}}
                            </template>
                        </Column>
                        <Column header="Тип" field="type" ></Column>
                        <Column header="Сессия" field="session_name" ></Column>
                        <Column header="Диапазон работы"  >
                            <template #body="slotProps">
                                {{timezoned(slotProps.data.date_start)}} - {{timezoned(slotProps.data.date_end)}}
                            </template>
                        </Column>
                        <Column header="Боты внутри">
                            <template #body="slotProps">
                                <div class="flex flex-column" v-html="n2br(slotProps.data.description)">
                                </div>
                            </template>
                        </Column>
                    </DataTable>
                </div>
                <div v-else>
                    <p>Реплаи отсутствуют.</p>
                </div>
            </template>
        </Card>

        <Toast position="top-center" />

    </AuthenticatedLayout>
</template>

<style scoped>

</style>
